import { render, staticRenderFns } from "./plasticAdditive.vue?vue&type=template&id=7423a50e&scoped=true"
import script from "./plasticAdditive.vue?vue&type=script&lang=js"
export * from "./plasticAdditive.vue?vue&type=script&lang=js"
import style0 from "./plasticAdditive.vue?vue&type=style&index=0&id=7423a50e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7423a50e",
  null
  
)

export default component.exports